import { ContentViewModel } from '@levelapp/softfabric';
export default class RadioButtonListViewModel extends ContentViewModel {
    constructor(view) {
        super(view);
        // The Intial State 
        this.initialState({
            id: -1,
        });
        // BINDINGS
        this.onCheck = this.onCheck.bind(this);
    }
    OnClickedValue() {
        this.props().OnClickedValue(this.state().id);
    }
    onCheck(id) {
        if (this.state().id && this.state().id == id) {
            //DO NOTHING
            // IF YOU WANT TO REMOVE THE CHECK.
        }
        else {
            this.setField({ id: id });
        }
    }
    CurrentState() {
        return this.state().id;
    }
}
